export const formatDateTime = (date: Date, fixedTime?: string): string => {
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const time = fixedTime ?? "00:00:00";
  return `${year}-${month}-${day}T${time}Z`;
};
